import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FILTER_CONTENT_ID, TenantConfig } from "../../../app.constants";
import { ConfigurationItem } from "../../../_objects/tenant-config";
import { TenantConfigService } from "../../../_services/http-api/tenant-config.service";
import { SearchSelectOption } from "../../component/search-combo-box/search-select-option";

export class ComboBoxOption {
  contentId: string;
  placeholder: string;
  selectedValue: string | boolean;
  options: SearchSelectOption[];
  isCheckBox: boolean;

  constructor(contentId: string, placeholder: string, options: SearchSelectOption[], selectedId: string | boolean = null, isCheckBox = false) {
    this.contentId = contentId;
    this.placeholder = placeholder;
    this.selectedValue = selectedId;
    this.options = options;
    this.isCheckBox = isCheckBox;
  }
}

export class FilterData {
  id: string;
  value: string | boolean;
  label: string;

  constructor(id: string, value: string | boolean, label: string) {
    this.id = id;
    this.value = value;
    this.label = label;
  }
}

@Component({
  selector: "app-filter-select-dialog",
  templateUrl: "./filter-select-dialog.component.html",
  styleUrls: ["./filter-select-dialog.component.scss"],
  standalone: false
})
export class FilterSelectDialogComponent implements OnInit {
  readonly ownerKey = TenantConfig.SubjectAttributeOwner.KEY;
  readonly countryKey = TenantConfig.SubjectAttributeCountry.KEY;
  readonly stateKey = TenantConfig.SubjectAttributeState.KEY;
  readonly districtKey = TenantConfig.SubjectAttributeDistrict.KEY;
  readonly siteKey = TenantConfig.SubjectAttributeSite.KEY;
  readonly projectKey = TenantConfig.SubjectAttributeProject.KEY;

  comboBoxOptions: ComboBoxOption[] = [];
  selectedFilters = new Map<string, string | boolean>();
  status: ComboBoxOption;
  subjectModel: ComboBoxOption;
  subject: ComboBoxOption;
  own: ComboBoxOption;
  selectedOnly: ComboBoxOption;
  owner: ComboBoxOption;
  country: ComboBoxOption;
  state: ComboBoxOption;
  district: ComboBoxOption;
  site: ComboBoxOption;
  project: ComboBoxOption;
  tenantConfigs: ConfigurationItem[] = [];
  @Output() changedValue = new EventEmitter<string>();
  @Output() changedFilter = new EventEmitter<FilterData[]>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tenantConfigService: TenantConfigService
  ) {
    if (data.hasOwnProperty("comboBoxOptions")) {
      this.comboBoxOptions = this.data.comboBoxOptions;
      this.comboBoxOptions.forEach((opts) => this.selectedFilters.set(opts.contentId, opts.selectedValue));

      this.status = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.STATUS);
      this.subjectModel = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.SUBJECT_MODEL);
      this.subject = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.SUBJECT);
      this.own = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.IS_OWN);
      this.selectedOnly = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.SELECTED_ONLY);
      this.owner = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.OWNER);
      this.country = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.COUNTRY);
      this.state = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.STATE);
      this.district = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.DISTRICT);
      this.site = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.SITE);
      this.project = this.comboBoxOptions.find((opt) => opt.contentId === FILTER_CONTENT_ID.PROJECT);

      this.tenantConfigs = this.tenantConfigService.tenantConfig;
    }
  }

  ngOnInit() {
    this.setPlaceHolder();
  }

  changeValue(contentId: string, selectedValue: string | boolean): void {
    const target = this.comboBoxOptions.find((opt) => opt.contentId === contentId);
    if (target) {
      target.selectedValue = selectedValue;
      this.selectedFilters.set(contentId, selectedValue);
      this.changedValue.emit(contentId);
    }
  }

  apply() {
    let filters: FilterData[] = [];
    this.selectedFilters.forEach((value, key) => filters.push(new FilterData(key, value, this.getLabel(key, value))));

    // nullもしくはfalseは取り除く
    filters = filters.filter((f) => (typeof f.value === "string" && f.value !== null) || (typeof f.value === "boolean" && f.value === true));
    this.changedFilter.emit(filters);
  }

  clear() {
    this.changedFilter.emit([]);
  }

  setPlaceHolder() {
    if (this.tenantConfigs?.length) {
      if (this.owner) {
        const ownerLabel = this.tenantConfigs.find((c) => c.key === TenantConfig.LabelOfOwner.KEY)?.value as string;
        this.owner.placeholder = ownerLabel ? ownerLabel : TenantConfig.DefaultConfigurationValues.LabelOfOwner;
      }

      if (this.country) {
        const countryLabel = this.tenantConfigs.find((c) => c.key === TenantConfig.LabelOfCountry.KEY)?.value as string;
        this.country.placeholder = countryLabel ? countryLabel : TenantConfig.DefaultConfigurationValues.LabelOfCountry;
      }

      if (this.state) {
        const stateLabel = this.tenantConfigs.find((c) => c.key === TenantConfig.LabelOfState.KEY)?.value as string;
        this.state.placeholder = stateLabel ? stateLabel : TenantConfig.DefaultConfigurationValues.LabelOfState;
      }

      if (this.district) {
        const districtLabel = this.tenantConfigs.find((c) => c.key === TenantConfig.LabelOfRegion.KEY)?.value as string;
        this.district.placeholder = districtLabel ? districtLabel : TenantConfig.DefaultConfigurationValues.LabelOfRegion;
      }

      if (this.site) {
        const siteLabel = this.tenantConfigs.find((c) => c.key === TenantConfig.LabelOfSite.KEY)?.value as string;
        this.site.placeholder = siteLabel ? siteLabel : TenantConfig.DefaultConfigurationValues.LabelOfSite;
      }

      if (this.project) {
        const projectLabel = this.tenantConfigs.find((c) => c.key === TenantConfig.LabelOfProject.KEY)?.value as string;
        this.project.placeholder = projectLabel ? projectLabel : TenantConfig.DefaultConfigurationValues.LabelOfProject;
      }
    }
  }

  getLabel(contentId: string, selectValue: string | boolean) {
    const opt = this.comboBoxOptions.find((o) => o.contentId === contentId);
    if (!opt) {
      return null;
    } else if (opt.isCheckBox) {
      return opt.selectedValue ? opt.placeholder : null;
    } else {
      return opt.options.find((o) => o.value === selectValue)?.label;
    }
  }

  isHide(attrKey: string): boolean {
    const config = this.tenantConfigs?.find((c) => c.key === attrKey);
    return config && config.value === TenantConfig.HIDE;
  }
}
